import templateUrl from "webmodals/action-list.htm";
import open from "webmodals/open";
import basicController from "servicestack/basic.controller.properties";

export default ({
  title = "Select...",
  subTitle = "",
  actions = {},
  moreProps = {},
  rawBodyTemplateUrl,
  bodyTemplateUrl,
  footerTemplateUrl,
  size = "md",
  backdrop = "static",
  placement = undefined, // "right",
  body = null
}) =>
  open({
    size,
    backdrop,
    templateUrl,
    placement,
    controller() {
      const $ctrl = this;
      basicController($ctrl);
      Object.assign(
        $ctrl,
        {
          title,
          subTitle,
          actions,
          rawBodyTemplateUrl,
          bodyTemplateUrl,
          footerTemplateUrl,
          size,
          body
        },
        moreProps
      );
    },
    bindToController: true,
    controllerAs: "$ctrl"
  }).result;
